import initialState from '../initialstate';
import {dashboardTabId} from '../../util/uiconstants';
import {UPDATE_FILTER_DASHBOARD_TILES, CLEAR_FILTER_DASHBOARD_TILES} from '../../actions/actiontypes';

export default function dashboardFiltersReducer(state = initialState.dashboardFilters, action) {
	switch (action.type) {
		case UPDATE_FILTER_DASHBOARD_TILES: {
			switch (action?.tab) {
				case dashboardTabId.milestones:
					return {...state, milestones: {...action.filters}};
				case dashboardTabId.canvasClientPortal:
					return {...state, ccp: {...action.filters}};
				case dashboardTabId.insights:
					return {...state, insight: {...action.filters}};
				case dashboardTabId.projectManagement:
					return {...state, projectManagement: {...action.filters}};
				case dashboardTabId.reporting:
					return {...state, reporting: {...action.filters}};
				case dashboardTabId.groupAudit:
					return {...state, groupAudit: {...action.filters}};
				case dashboardTabId.groupRiskAssessment:
					return {...state, groupRiskAssessment: {...action.filters}};
				default:
					return state;
			}
		}
		case CLEAR_FILTER_DASHBOARD_TILES: {
			switch (action?.tab) {
				case dashboardTabId.milestones:
					return {...state, milestones: null};
				case dashboardTabId.canvasClientPortal:
					return {...state, ccp: null};
				case dashboardTabId.insights:
					return {...state, insight: null};
				case dashboardTabId.projectManagement:
					return {...state, projectManagement: null};
				case dashboardTabId.reporting:
					return {...state, reporting: null};
				case dashboardTabId.groupAudit:
					return {...state, groupAudit: null};
				case dashboardTabId.groupRiskAssessment:
					return {...state, groupRiskAssessment: null};
				default:
					return state;
			}
		}
		default:
			return state;
	}
}
